export const isMobile = () => {
  const ua = navigator.userAgent.toLowerCase();
  // タブレット
  // iOS系
  if (ua.includes('ipad')) return true;
  // Android系
  if (ua.includes('android') && !ua.includes('mobile')) return true;

  // スマホ
  // iOS系
  if (ua.includes('iphone') || ua.includes('ipod')) return true;
  // Android系
  if (ua.includes('android') && ua.includes('mobile')) return true;
  // Windows Phone系
  if (ua.includes('windows phone')) return true;
  // BlackBerry系
  if (ua.includes('blackberry') || ua.includes('bb')) return true;

  return false;
}
